var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoFeedback(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 124,
    viewBox: "0 0 143 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.3001 105.7C98.3001 105.7 121 83.0001 121 54.9001C121 26.8001 98.2001 4.1001 70.3001 4.1001C42.3001 4.1001 19.6001 26.8001 19.6001 54.9001C19.6001 83.0001 42.3001 105.7 70.3001 105.7Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.7 5.6C125.246 5.6 126.5 4.3464 126.5 2.8C126.5 1.2536 125.246 0 123.7 0C122.154 0 120.9 1.2536 120.9 2.8C120.9 4.3464 122.154 5.6 123.7 5.6Z",
    fill: "#E7EBF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3 21.4999C23.8464 21.4999 25.1 20.2463 25.1 18.6999C25.1 17.1535 23.8464 15.8999 22.3 15.8999C20.7536 15.8999 19.5 17.1535 19.5 18.6999C19.5 20.2463 20.7536 21.4999 22.3 21.4999Z",
    fill: "#E7EBF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 75.5001C8.07188 75.5001 10.4 73.172 10.4 70.3001C10.4 67.4282 8.07188 65.1001 5.2 65.1001C2.32812 65.1001 0 67.4282 0 70.3001C0 73.172 2.32812 75.5001 5.2 75.5001Z",
    fill: "#E7EBF6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2447_6010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.611 28.2166V87.0543C118.611 88.7806 117.173 90.2192 115.446 90.2192H26.0389C24.3126 90.2911 22.874 88.8525 22.874 87.1262V28.2166C22.874 26.4184 24.3126 25.0518 26.0389 25.0518H115.446C117.244 25.0518 118.611 26.4903 118.611 28.2166Z",
    fill: "url(#paint0_linear_2447_6010)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.611 28.2166V32.7481H22.874V28.2166C22.874 26.4184 24.3126 25.0518 26.0389 25.0518H115.446C117.244 25.0518 118.611 26.4903 118.611 28.2166Z",
    fill: "url(#paint1_linear_2447_6010)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5437 55.5498C59.0135 55.5498 60.205 54.3582 60.205 52.8884C60.205 51.4186 59.0135 50.2271 57.5437 50.2271C56.0739 50.2271 54.8823 51.4186 54.8823 52.8884C54.8823 54.3582 56.0739 55.5498 57.5437 55.5498Z",
    fill: "#989FB0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0134 55.5498C85.4832 55.5498 86.6748 54.3582 86.6748 52.8884C86.6748 51.4186 85.4832 50.2271 84.0134 50.2271C82.5436 50.2271 81.3521 51.4186 81.3521 52.8884C81.3521 54.3582 82.5436 55.5498 84.0134 55.5498Z",
    fill: "#989FB0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0943 73.0281H66.7506C65.4559 73.0281 64.377 71.9491 64.377 70.6544C64.377 69.3597 65.4559 68.2808 66.7506 68.2808H75.0224C76.3171 68.2808 77.396 69.3597 77.396 70.6544C77.468 71.9491 76.389 73.0281 75.0943 73.0281Z",
    fill: "#989FB0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.118 30.2306C27.7139 30.2306 28.1969 29.7476 28.1969 29.1517C28.1969 28.5558 27.7139 28.0728 27.118 28.0728C26.5221 28.0728 26.0391 28.5558 26.0391 29.1517C26.0391 29.7476 26.5221 30.2306 27.118 30.2306Z",
    fill: "#F9FAFB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4984 30.2306C31.0942 30.2306 31.5773 29.7476 31.5773 29.1517C31.5773 28.5558 31.0942 28.0728 30.4984 28.0728C29.9025 28.0728 29.4194 28.5558 29.4194 29.1517C29.4194 29.7476 29.9025 30.2306 30.4984 30.2306Z",
    fill: "#F9FAFB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M33.951 30.2306C34.5469 30.2306 35.0299 29.7476 35.0299 29.1517C35.0299 28.5558 34.5469 28.0728 33.951 28.0728C33.3551 28.0728 32.8721 28.5558 32.8721 29.1517C32.8721 29.7476 33.3551 30.2306 33.951 30.2306Z",
    fill: "#F9FAFB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.727 17.4275C114.008 17.4275 113.432 16.852 113.432 16.1328V1.67509C113.432 0.955801 114.008 0.380371 114.727 0.380371C115.446 0.380371 116.022 0.955801 116.022 1.67509V16.1328C116.022 16.852 115.446 17.4275 114.727 17.4275Z",
    fill: "#989FB0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M125.229 28.5047C125.229 27.7854 125.804 27.21 126.523 27.21H140.981C141.7 27.21 142.276 27.7854 142.276 28.5047C142.276 29.224 141.7 29.7994 140.981 29.7994H126.523C125.804 29.7994 125.229 29.224 125.229 28.5047Z",
    fill: "#989FB0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.078 19.1535C123.574 18.65 123.574 17.7869 124.078 17.2834L134.364 7.06952C134.867 6.56602 135.73 6.56602 136.234 7.06952C136.737 7.57302 136.737 8.43616 136.234 8.93967L126.02 19.1535C125.444 19.657 124.581 19.657 124.078 19.1535Z",
    fill: "#989FB0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2447_6010",
    x: 0.874023,
    y: 14.0518,
    width: 139.737,
    height: 109.17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2447_6010"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2447_6010",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2447_6010",
    x1: 70.7114,
    y1: 23.5443,
    x2: 70.7114,
    y2: 90.9243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2447_6010",
    x1: 114.814,
    y1: 25.0518,
    x2: 25.9589,
    y2: 28.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFeedback);
export default __webpack_public_path__ + "static/media/no-feedback.b1f9478736aa39c30229a811313f4df5.svg";
export { ForwardRef as ReactComponent };